import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from '../../globalStyles';
import {
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  ImgWrapper,
  Img
} from './InfoSection.elements';
import home from '../../images/elevators/home.png';
import hospital from '../../images/elevators/hospital.png';
import frieght from '../../images/elevators/frieght.png';
import passengers from '../../images/elevators/passengers.png';
import img1 from '../../images/img1.png';
import { BsDot } from 'react-icons/bs'
function Elevators ({
  primary,
  lightBg,
  topLine,
  lightTopLine,
  lightText,
  lightTextDesc,
  headline,
  description,
  buttonLabel,
  img,
  bglight,
  alt,
  imgStart,
  start,
  boxsh
}) {
  return (
    <>
      <InfoSec lightBg={true} boxsh={false}>
        <Container>
            <InfoRow imgStart={imgStart}>
          <InfoColumn>
              <ImgWrapper >
                <Img src={img1} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>We provide Elevators for all buildings.</Heading>
                <TopLine style={{ color:'#fff'}} lightTopLine={lightTopLine} bglight={  bglight}
>Product Highlights:</TopLine>
                <Subtitle lightTextDesc={true}> <BsDot  style={{ fontSize:"15px" }} />Machine room and machine roomless designs.         <br /> <BsDot  style={{ fontSize:"15px" }} />We offer high speed solutions.-Industry leading after sales service, maintenance plans are applied according the type of your building.<br/><BsDot  style={{ fontSize:"15px" }} />We utilize dual core, high performance, micro controllers to ensure maximum safety and performance. Destination control systems are also an option with our elevators.                  <br /> <BsDot  style={{ fontSize:"15px" }} />  Our elevator consume less electricity,  our innovative machines and drive controller, Moreover, use of L.E.D lighting across all of our cabins further saves your electricity bills..</Subtitle>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <InfoRow imgStart={imgStart} style={{ flexDirection:'row-reverse'}}>
          <InfoColumn>
              <ImgWrapper start={start}>
                <Img src={passengers} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Passenger Elevator</Heading>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <br />
                    <br/>

          <InfoRow >
          <InfoColumn>
              <ImgWrapper>
                <Img src={home} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Home elevator</Heading>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <br/>
                    <br/>

          <InfoRow imgStart={imgStart} style={{ flexDirection:'row-reverse'}}>
          <InfoColumn>
              <ImgWrapper  start={start}>
                <Img src={hospital} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Hospital bed elevator</Heading>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
             <br/>
                    <br/>

            <InfoRow >
          <InfoColumn>
              <ImgWrapper  start={start}>
                <Img src={frieght} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Freight elevator</Heading>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
        </Container>
      </InfoSec>
    </>
  );
}

export default Elevators;
